import React from 'react';
import Icon from '../../../components/AppIcon';

const AudienceDemographics = ({ demographics }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Kitle Demografisi</h2>
      <div className="space-y-6">
        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-foreground">Yaş Dağılımı</span>
            <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className="space-y-2">
            {demographics?.ageGroups?.map((group, index) => (
              <div key={index}>
                <div className="flex items-center justify-between text-sm mb-1">
                  <span className="text-muted-foreground">{group?.range}</span>
                  <span className="font-medium text-foreground">%{group?.percentage}</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary rounded-full transition-all"
                    style={{ width: `${group?.percentage}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-foreground">Cinsiyet Dağılımı</span>
            <Icon name="PieChart" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            {demographics?.gender?.map((item, index) => (
              <div key={index} className="p-3 bg-muted rounded-lg">
                <p className="text-2xl font-bold text-foreground">%{item?.percentage}</p>
                <p className="text-sm text-muted-foreground mt-1">{item?.type}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-foreground">Konum Dağılımı</span>
            <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div className="space-y-2">
            {demographics?.locations?.map((location, index) => (
              <div key={index} className="flex items-center justify-between p-2 hover:bg-muted rounded-lg transition-smooth">
                <span className="text-sm text-foreground">{location?.city}</span>
                <span className="text-sm font-medium text-muted-foreground">%{location?.percentage}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudienceDemographics;